import { call, put } from 'redux-saga/effects';
import { CallApi } from './call_api';
import { ACTIONS, APIS, STORAGE } from '../common/config/config';
function* setLoader(status) {
  yield put({
    type: status ? ACTIONS.LOADER.SHOW_LOADER : ACTIONS.LOADER.HIDE_LOADER,
  });
}

export function* getCountryList(action) {
  try {
    yield setLoader(true);
    const data = action.payload;
    const resp = yield call(CallApi.GET, APIS.UTILITY.GET_COUNTRY, data, true);
    if (resp.status >= 200 && resp.status < 300) {
      yield put({
        type: ACTIONS.UTILITY.GET_COUNTRY,
        payload: resp.data,
      });
      yield setLoader(false);
      // eslint-disable-next-line no-unused-expressions
      action && action.callbackSuccess && action.callbackSuccess(resp);
    } else {
      yield setLoader(false);
      // eslint-disable-next-line no-unused-expressions
      action && action.callbackError && action.callbackError(resp);
    }
  } catch (e) {
    yield setLoader(false);
    // eslint-disable-next-line no-unused-expressions
    action && action.callbackError && action.callbackError(e);
  }
}

export function* getStateList(action) {
  try {
    yield setLoader(true);
    const data = action.payload;
    const resp = yield call(CallApi.GET, APIS.UTILITY.GET_STATE, data, true);
    if (resp.status >= 200 && resp.status < 300) {
      yield put({
        type: ACTIONS.UTILITY.GET_STATE,
        payload: resp.data,
      });
      yield setLoader(false);
      // eslint-disable-next-line no-unused-expressions
      action && action.callbackSuccess && action.callbackSuccess(resp);
    } else {
      yield setLoader(false);
      // eslint-disable-next-line no-unused-expressions
      action && action.callbackError && action.callbackError(resp);
    }
  } catch (e) {
    yield setLoader(false);
    // eslint-disable-next-line no-unused-expressions
    action && action.callbackError && action.callbackError(e);
  }
}

export function* getCityList(action) {
  try {
    yield setLoader(true);
    const data = action.payload;
    const resp = yield call(CallApi.GET, APIS.UTILITY.GET_CITY, data, true);
    if (resp.status >= 200 && resp.status < 300) {
      yield put({
        type: ACTIONS.UTILITY.GET_CITY,
        payload: resp.data,
      });
      yield setLoader(false);
      // eslint-disable-next-line no-unused-expressions
      action && action.callbackSuccess && action.callbackSuccess(resp);
    } else {
      yield setLoader(false);
      // eslint-disable-next-line no-unused-expressions
      action && action.callbackError && action.callbackError(resp);
    }
  } catch (e) {
    yield setLoader(false);
    // eslint-disable-next-line no-unused-expressions
    action && action.callbackError && action.callbackError(e);
  }
}

export function* getDashboardCount(action) {
  try {
    yield setLoader(true);
    const data = action.payload;
    const resp = yield call(CallApi.GET, APIS.UTILITY.DASHBOARD_COUNT, data, true);
    if (resp.status >= 200 && resp.status < 300) {
      yield put({
        type: ACTIONS.UTILITY.DASHBOARD_COUNT,
        payload: resp.data,
      });
      yield setLoader(false);
      // eslint-disable-next-line no-unused-expressions
      action && action.callbackSuccess && action.callbackSuccess(resp);
    } else {
      yield setLoader(false);
      // eslint-disable-next-line no-unused-expressions
      action && action.callbackError && action.callbackError(resp);
    }
  } catch (e) {
    yield setLoader(false);
    // eslint-disable-next-line no-unused-expressions
    action && action.callbackError && action.callbackError(e);
  }
}

export function* getAllReport(action) {
  try {
    yield setLoader(true);
    const data = action.payload;
    const resp = yield call(CallApi.GET, APIS.UTILITY.GET_ALL_REPORT, data, true);
    if (resp.status >= 200 && resp.status < 300) {
      yield put({
        type: ACTIONS.UTILITY.GET_ALL_REPORT,
        payload: resp.data,
      });
      yield setLoader(false);
      // eslint-disable-next-line no-unused-expressions
      action && action.callbackSuccess && action.callbackSuccess(resp);
    } else {
      yield setLoader(false);
      // eslint-disable-next-line no-unused-expressions
      action && action.callbackError && action.callbackError(resp);
    }
  } catch (e) {
    yield setLoader(false);
    // eslint-disable-next-line no-unused-expressions
    action && action.callbackError && action.callbackError(e);
  }
}

export function* reportViewOrDownload(action) {
  try {
    yield setLoader(true);
    const data = action.payload;
    const resp = yield call(CallApi.POST, APIS.UTILITY.REPORT_VIEW_OR_DOWNLOAD, data, true);
    if (resp.status >= 200 && resp.status < 300) {
      yield setLoader(false);
      // eslint-disable-next-line no-unused-expressions
      action && action.callbackSuccess && action.callbackSuccess(resp);
    } else {
      yield setLoader(false);
      // eslint-disable-next-line no-unused-expressions
      action && action.callbackError && action.callbackError(resp);
    }
  } catch (e) {
    yield setLoader(false);
    // eslint-disable-next-line no-unused-expressions
    action && action.callbackError && action.callbackError(e);
  }
}